module.exports = __webpack_public_path__ + "img/投诉举报.30da358e.png";